import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Screenshots from '../components/Screenshots';
import Download from '../components/Download';

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <Screenshots />
      <Download />
    </>
  );
};

export default Home;
